<template>
  <SysDialog v-model="DIALOG_ATIVO_COMPUTED" titulo="Exportação Shop">
    <SysDatePicker
      v-model="relatorio.validade"
      titulo_label="Data de Validade"
      outlined
    />

    <div class="d-flex mt-n3">
      <div class="w-50-porcento">
        <v-select
          v-model="relatorio.usar_icms"
          label="Usar ICMS"
          outlined
          :items="selects.sim_ou_nao"
          item-value="valor"
          item-text="descricao"
          @input="relatorio.porcentual_icms = 0"
        />
      </div>

      <div class="pl-3 w-50-porcento">
        <TextFieldFormatadorDeValor
          v-model="relatorio.porcentual_icms"
          label="Porcentual ICMS"
          outlined
          :disabled="relatorio.usar_icms === 'N'"
          @focus="ev => ev.target.select()"
          suffix="%"
        />
      </div>
    </div>

    <div class="d-flex mt-n3">
      <div class="w-50-porcento">
        <v-select
          v-model="relatorio.usar_ipi"
          label="Usar IPI"
          outlined
          :items="selects.sim_ou_nao"
          item-value="valor"
          item-text="descricao"
          @input="relatorio.porcentual_ipi = 0"
        />
      </div>

      <div class="pl-3 w-50-porcento">
        <TextFieldFormatadorDeValor
          v-model="relatorio.porcentual_ipi"
          label="Porcentual IPI"
          outlined
          :disabled="relatorio.usar_ipi === 'N'"
          @focus="ev => ev.target.select()"
          suffix="%"
        />
      </div>
    </div>

    <template #actions>
      <v-btn
        color="primary"
        text
        :disabled="! EXPORTACAO_ATIVA_COMPUTED"
        @click="gerarRelatorio"
      >
        Gerar Relatório
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import $axios from "@/api/api";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysDatePicker from "@/components/utils/SysDatePicker.vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";

export default {
  name: "ExportacaoShopControll9",
  components: {TextFieldFormatadorDeValor, SysDatePicker, SysDialog},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    pedido_selecionado: Object,
  },
  emits: ['update:modelValue'],
  data: () => ({
    selects: {
      sim_ou_nao: [
        { valor: 'S', descricao: 'SIM' },
        { valor: 'N', descricao: 'NÃO' },
      ],
    },
    relatorio: {
      validade: '',
      usar_icms: 'N',
      porcentual_icms: 0,
      usar_ipi: 'N',
      porcentual_ipi: 0,
    }
  }),
  computed: {
    DIALOG_ATIVO_COMPUTED: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    EXPORTACAO_ATIVA_COMPUTED() {
      return this.relatorio.validade
        && this.relatorio.validade.length === 10
        && new Date(this.relatorio.validade) > Date.now();
    }
  },
  watch: {
    DIALOG_ATIVO_COMPUTED(valor) {
      if (! valor) {
        this.resetarDialog();
      }
    }
  },
  methods: {
    gerarRelatorio() {
      if (!this.EXPORTACAO_ATIVA_COMPUTED) return;

      const url = $axios.defaults.baseURL.concat(
        '/relatorios/pedido-compra/shop-control9?',
        `idpedido=${this.pedido_selecionado.idpedido}&`,
        `validade=${this.relatorio.validade}&`,
        `usar_icms=${this.relatorio.usar_icms}&`,
        `porcentual_icms=${this.relatorio.porcentual_icms}&`,
        `usar_ipi=${this.relatorio.usar_ipi}&`,
        `porcentual_ipi=${this.relatorio.porcentual_ipi}`,
      );

      window.open(url, "_blank");

      this.resetarDialog();
    },
    resetarDialog() {
      this.DIALOG_ATIVO_COMPUTED = false;
      this.relatorio.validade = '';
      this.relatorio.usar_icms = 'N';
      this.relatorio.porcentual_icms = 0;
      this.relatorio.usar_ipi = 'N';
      this.relatorio.porcentual_ipi = 0;
    }
  }
}
</script>
